import type { LucideIcon } from "lucide-react";
import {
  LayoutDashboard,
  Boxes,
  FileText,
  HeartHandshake,
  Briefcase,
  Search,
  FileEdit,
  Mail,
  Store,
  Send,
  Image,
  Settings,
  PanelBottom,
} from "lucide-react";

export type NavItem = {
  label: string;
  to: string;
  icon: LucideIcon;
};

export type NavGroup = {
  title: string;
  items: NavItem[];
};

export const NAV_GROUPS: NavGroup[] = [
  {
    title: "Genel",
    items: [{ label: "Panel", to: "/", icon: LayoutDashboard }],
  },
  {
    title: "İçerik",
    items: [
      { label: "Markalar", to: "/brands", icon: Boxes },
      { label: "Blog", to: "/blog", icon: FileText },
      { label: "Sosyal Sorumluluk", to: "/social", icon: HeartHandshake },
      { label: "İş İlanları", to: "/jobs", icon: Briefcase },
    ],
  },
  {
    title: "Sayfalar & SEO",
    items: [
      { label: "Sayfalar & SEO", to: "/pages", icon: Search },
      { label: "Sayfa İçerikleri", to: "/page-content", icon: FileEdit },
      { label: "Footer", to: "/footer", icon: PanelBottom },
    ],
  },
  {
    title: "Talepler",
    items: [
      { label: "İletişim", to: "/contacts", icon: Mail },
      { label: "Bayi Başvuruları", to: "/dealers", icon: Store },
      { label: "İş Başvuruları", to: "/job-applications", icon: Briefcase },
      { label: "Bülten", to: "/newsletter", icon: Send },
    ],
  },
  {
    title: "Medya",
    items: [{ label: "Medya", to: "/media", icon: Image }],
  },
  {
    title: "Sistem",
    items: [{ label: "Ayarlar", to: "/settings", icon: Settings }],
  },
];
